import { Route } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { teamGuard } from './core/guards/team.guard';
import { roleGuard } from './core/guards/role.guard';
import { pdmaMemberGuard } from './core/guards/pdma-member.guard';
import { UserRole } from '@pdma/shared-types';

export const appRoutes: Route[] = [
  {
    path: 'login',
    data: { animation: 'Login' },
    loadComponent: () =>
      import('./pages/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'auth/callback',
    data: { animation: 'AuthCallback' },
    loadComponent: () =>
      import('./pages/auth-callback/auth-callback.component').then(
        (m) => m.AuthCallbackComponent,
      ),
  },
  {
    path: 'select-team',
    canActivate: [authGuard],
    data: { animation: 'SelectTeam' },
    loadComponent: () =>
      import('./pages/team-selection/team-selection.component').then(
        (m) => m.TeamSelectionComponent,
      ),
  },
  {
    path: '',
    canActivate: [authGuard, teamGuard],
    children: [
      {
        path: '',
        data: { animation: 'Home' },
        loadComponent: () =>
          import('./pages/home/home.component').then((m) => m.HomeComponent),
      },
      {
        path: 'about',
        data: { animation: 'About' },
        loadComponent: () =>
          import('./pages/about/about.component').then((m) => m.AboutComponent),
      },
      {
        path: 'assessment',
        data: { animation: 'Assessment' },
        loadChildren: () =>
          import('./pages/assessment/assessment.routes').then((m) => m.ASSESSMENT_ROUTES),
      },
      {
        path: 'results',
        canActivate: [pdmaMemberGuard],
        data: { animation: 'Results' },
        loadChildren: () =>
          import('./pages/results/results.routes').then((m) => m.RESULTS_ROUTES),
      },
      {
        path: 'admin',
        data: { animation: 'Admin' },
        canActivate: [roleGuard(UserRole.ADMIN, UserRole.COMMS_ADMIN)],
        loadChildren: () =>
          import('./pages/admin/admin.routes').then((m) => m.ADMIN_ROUTES),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
